import React, {useContext} from 'react'
import {NullAsDefault, renderMail, renderPhone} from 'views/Shared'
import {Avatar, message} from "antd";
import {renderIf, renderIfElse} from "../../../Shared";
import {FaUserTie} from "react-icons/fa6";
import getAvatar from "../../../../helpers/getAvatar";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import copyToClipboard from "copy-to-clipboard";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import _ from 'lodash'
import {IoCheckmarkCircle, IoCopyOutline, IoEllipseOutline} from "react-icons/io5";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {ItemInformation} from 'components/common/ItemInformation'
import {TeacherActionTypes} from "../../../AppLocals/Course";
import {PiLinkSimpleBold} from "react-icons/pi";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {DatePlaceItem} from "../../../../components/common/DatePlaceItem";
import {DoubleValueItem} from "../../../../components/common/DoubleValueItem";
import classNames from "classnames";
import getAliasName from "../../../../helpers/getAliasName";
import {getGroupColor} from "./renderCourseClassStudent";
import {getInitials, renderGenderBadge} from "./renderStudent";
import {BsChevronRight, BsEyeFill} from "react-icons/bs";
import {HiPhone} from "react-icons/hi2";
import {MdOutlineEmail} from "react-icons/md";
import {GoDotFill} from "react-icons/go";

export const renderTeacher = ({translate: t, isLg, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        user,
        prefix_title,
        fullname,
        date_of_birth,
        place_of_birth,
        contact_phone,
        contact_email,
        teacher_idcode,
        contact_address,
        hashtags = "",
        gender,
    } = item ?? {}

    const {isSm} = useContext(LayoutContext)
    const inactive = item?.active === 0
    const tags = (hashtags || "").split(",").filter(e => !!e);

    return (
        <div key={index} className="p-4 flex flex-col custom-item-render relative list-item">
            <div className="flex gap-3">
                <Avatar
                    size={40}
                    style={{marginTop: 4}}
                    className={classNames("flex flex-center background-200", inactive && 'opacity-40')}
                    src={getAvatar(item) || user?.avatar}
                    icon={<FaUserTie size={20} className="text-color-500"/>}
                />
                <div className={classNames("flex flex-col flex-1 min-w-0", inactive && 'opacity-40')}>
                    <h2>
                        {renderIfElse(
                            user,
                            <Link
                                to={getLinkToDetail(user)}
                                style={{marginBottom: 4}}
                                className={classNames("font-bold text-lg no-underline leading-snug", inactive ? 'text-color-300' : 'text-color-000')}>
                                {(user?.patron_saint_name || prefix_title) && (
                                    <span className="mr-1 font-medium text-sm text-gray-600">
                                        {user?.patron_saint_name ? user?.patron_saint_name : prefix_title}
                                    </span>
                                )}
                                {fullname}
                                <PiLinkSimpleBold size={11} className="ml-1 text-primary-400"/>
                            </Link>,
                            <div
                                onClick={() => {handleAction(TeacherActionTypes.TEACHER_READ, item)}}
                                style={{marginBottom: 4}} className="font-medium text-color-100 leading-snug cursor-pointer">
                                {prefix_title && (<span className="mr-1 text-sm italic">{prefix_title}</span>)}
                                <span className={classNames("font-bold text-base", inactive ? 'text-color-300' : 'text-color-000 hover:text-color-100')}>{fullname}</span>
                            </div>
                        )}
                    </h2>
                    <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-1">
                        {renderIf(
                            teacher_idcode,
                            <div className="tracking-wider">
                                <span className="text-color-400 whitespace-no-wrap">
                                    {isSm ? '#' : `${t('teacher code')} : `}
                                </span>
                                <span
                                    onClick={() => {
                                        copyToClipboard(teacher_idcode)
                                        message.info(t('copied'))
                                    }}
                                    className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                {teacher_idcode}
                                    <IoCopyOutline size={12} className="ml-1"/>
                            </span>
                            </div>
                        )}
                    </div>
                    <div className="my-2 border-b border-color-50"/>
                    <div className="flex flex-col flex-1 gap-1">
                        {renderIf(
                            tags.length > 0,
                            <div className="flex gap-2">
                                {tags.map((ee, ii) => (
                                    <span
                                        key={ii}
                                        style={{width: 'fit', padding: '2px 8px', fontSize: 10, borderRadius: 999}}
                                        className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                                        {ee}
                                    </span>
                                ))}
                            </div>
                        )}
                        <div className="flex flex-col gap-1">
                            {_.some([date_of_birth, place_of_birth]) && (
                                <DatePlaceItem
                                    showIcon={true}
                                    label="date of birth"
                                    date={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                    place={place_of_birth}
                                    className="italic tracking-wider"
                                />
                            )}
                            {renderIf(
                                gender !== 0,
                                <ItemInformation
                                    showIcon={true}
                                    label="gender"
                                    value={t(getLabelOfGender(gender))}
                                    className="italic tracking-wider"
                                />
                            )}
                        </div>
                        {renderIf(
                            _.some([contact_phone, contact_email]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst="contact"
                                valueFirst={renderPhone(contact_phone)}
                                labelSecond={contact_email && " - " || ''}
                                valueSecond={renderMail(contact_email)}
                                className="italic tracking-wider"
                            />
                        )}
                        {renderIf(
                            contact_address,
                            <ItemInformation
                                showIcon={true}
                                label="address"
                                value={contact_address}
                                className="italic tracking-wider"
                            />
                        )}
                    </div>
                </div>
            </div>

            {(inactive) && (
                <div className={isLg ? 'absolute right-10 bottom-10' : 'mt-2 flex justify-end'}>
                    <span className="px-3 py-0.5 border border-orange-300 rounded-full font-medium text-xs md:text-2xs text-orange-400">
                        {t('temporarily inactive')}
                    </span>
                </div>
            )}

            <div className="absolute right-8 top-8 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

// Layout "Thẻ" (mặc định mobile) + "Bảng" (mặc định desktop) cho trang Quản lý Giáo viên/Nhân sự
// (Teachers.js) - theo đúng mockup bạn gửi, tương tự renderStudentCardItem/renderStudentTableRow
// (renderStudent.js). renderTeacher gốc phía trên GIỮ NGUYÊN (không chỗ nào khác dùng, nhưng vẫn để
// đó phòng khi cần).
//
// majors/fields/experiences/degrees (Teacher.php) là 4 field TEXTAREA tự do (tối đa 1000 ký tự,
// KHÔNG phải tag ngắn) - badge "Bằng cấp" (degrees) và dòng phụ "Nghề nghiệp - Lĩnh vực" (occupation
// - fields) dùng đúng dữ liệu thật nhưng phải truncate (class truncate + max-width) vì không đảm bảo
// admin luôn nhập ngắn gọn như ví dụ mockup.
const renderTeacherHeader = ({item, t, onView}) => {
    const {user, prefix_title, fullname} = item ?? {}
    const patronSaint = getAliasName(item, 'patron_saint')
    return (
        <span className="flex flex-col gap-1 font-bold text-sm text-color-000 leading-snug truncate">
            {(prefix_title || patronSaint) && (
                <span className="flex items-baseline gap-1">
                    {prefix_title && (
                        <span className="font-medium text-xs text-gray-600 leading-snug truncate flex-shrink-0">{prefix_title}</span>
                    )}
                    {patronSaint && (
                        <span className="font-medium text-xs text-gray-600 leading-snug truncate flex-shrink-0">{patronSaint}</span>
                    )}
                </span>
            )}
            <span
                onClick={onView ? () => onView(item) : undefined}
                className={classNames("flex items-baseline gap-1", onView && "hover:text-primary cursor-pointer")}>
                 <span className="truncate">{fullname}</span>
                {user && <PiLinkSimpleBold size={11} className="flex-shrink-0 text-primary-400"/>}
            </span>
        </span>
    )
}

export const renderTeacherCardItem = ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        user, fullname, gender, edit,
        date_of_birth,
        contact_phone, contact_email,
        teacher_idcode,
        occupation, fields, degrees,
    } = item ?? {}

    const inactive = item?.active === 0
    const initials = getInitials(fullname)
    const color = getGroupColor(fullname)
    const isUserLinked = !!user?.id
    const birthYear = date_of_birth ? formatDate(date_of_birth, 'YYYY') : null

    return (
        <div key={index} className={classNames(
            "p-4 flex flex-col gap-3 border background rounded-2xl hover:shadow-md transition-all duration-300 relative custom-item-render",
            isUserLinked ? "border-green-200" : "border-color-100"
        )}>
            <div className={classNames("flex flex-col gap-3", inactive && "opacity-40")}>
                {/* Header: avatar + tên + bằng cấp */}
                <div className="flex items-start justify-between gap-2">
                    <div className="flex items-center gap-2.5 min-w-0">
                        {getAvatar(item) || user?.avatar ? (
                            <Avatar
                                size={40}
                                className="flex-shrink-0 flex flex-center background-200"
                                src={getAvatar(item) || user?.avatar}
                                icon={<FaUserTie size={18} className="text-color-500"/>}
                            />
                        ) : (
                            <div
                                style={{width: 40, height: 40, backgroundColor: color, flexShrink: 0}}
                                className="rounded-full flex flex-center">
                                <span className="text-white font-bold text-sm leading-none">{initials}</span>
                            </div>
                        )}
                        {renderTeacherHeader({item, t, onView: () => handleAction(TeacherActionTypes.TEACHER_READ, item)})}
                    </div>
                    {edit === true && (
                        isUserLinked ? (
                            <span className="px-2.5 py-1 rounded-full text-2xs font-bold flex items-center gap-1 flex-shrink-0 bg-green-50 text-green-600 whitespace-no-wrap">
                                <IoCheckmarkCircle size={11}/>
                                {t('user account linked')}
                            </span>
                        ) : (
                            <span className="px-2.5 py-1 rounded-full text-2xs font-medium flex items-center gap-1 flex-shrink-0 border border-color-200 text-color-400 whitespace-no-wrap">
                                <IoEllipseOutline size={10}/>
                                {t('user account not linked')}
                            </span>
                        )
                    )}
                </div>

                {/* Codes */}
                {(teacher_idcode || (isUserLinked && user?.username)) && (
                    <div className="flex flex-wrap items-center gap-1.5">
                        {teacher_idcode && (
                            <span
                                onClick={() => { copyToClipboard(teacher_idcode); message.info(t('copied')) }}
                                className="px-2 py-0.5 rounded-full background-100 font-mono text-2xs font-semibold cursor-pointer flex items-center gap-1 whitespace-no-wrap text-blue-500 hover:text-blue-700">
                                #{teacher_idcode}
                                <IoCopyOutline size={9}/>
                            </span>
                        )}
                        {isUserLinked && user?.username && (
                            <span className="px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-600 font-mono text-2xs font-semibold flex items-center gap-1 whitespace-no-wrap">
                                @{user.username}
                            </span>
                        )}
                    </div>
                )}

                {/* Liên hệ */}
                <div className="px-3 py-2 rounded-xl background-100 flex flex-col gap-1">
                    <span className="flex items-center gap-1.5 text-xs">
                        <HiPhone size={12} className="flex-shrink-0 text-color-400"/>
                        {contact_phone ? (
                            <span className="text-color-200 font-medium">{contact_phone}</span>
                        ) : (
                            <span className="text-color-400 italic">{t('not update')}</span>
                        )}
                    </span>
                    <span className="flex items-center gap-1.5 text-xs">
                        <MdOutlineEmail size={12} className="flex-shrink-0 text-color-400"/>
                        {contact_email ? (
                            <span className="text-color-200 font-medium truncate">{contact_email}</span>
                        ) : (
                            <span className="text-color-400 italic">{t('not update')}</span>
                        )}
                    </span>
                </div>

                {/* Footer: giới tính/năm sinh + actions */}
                <div className="flex items-center justify-between gap-2 pt-2.5 border-t border-color-50">
                    <div className="flex flex-col gap-1 min-w-0">
                        <div className="flex items-center gap-1.5 text-2xs text-color-300 whitespace-no-wrap">
                            {renderGenderBadge(gender, t)}
                            {(gender === 1 || gender === 2) && date_of_birth && <GoDotFill size={6} />}
                            {date_of_birth && <span className="font-medium">{formatDate(date_of_birth, 'DD/MM/YYYY')}</span>}
                        </div>
                        {/* Nghề nghiệp - lĩnh vực */}
                        {(occupation || fields || degrees) && (
                            <div className="flex items-center gap-1.5 text-xs text-color-300 truncate">
                                <span className="whitespace-no-wrap truncate">
                                    <GoDotFill size={8}/> {occupation}
                                </span>
                                {fields && (
                                    <span className="whitespace-no-wrap">
                                        <GoDotFill size={8}/> {fields}
                                    </span>
                                )}
                                {degrees && (
                                    <span className="whitespace-no-wrap">
                                        <GoDotFill size={8}/> {degrees}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="flex items-center gap-1.5 flex-shrink-0">
                        <button
                            type="button"
                            onClick={() => handleAction(TeacherActionTypes.TEACHER_READ, item)}
                            className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-primary-50 hover:bg-primary-100 text-primary-600 font-semibold text-xs whitespace-no-wrap">
                            {t('detail')}
                            <BsChevronRight size={11}/>
                        </button>
                        <div className="p-1.5 hover:background-200 rounded-lg cursor-pointer">
                            {renderContextMenu(item)}
                        </div>
                    </div>
                </div>
            </div>
            {inactive && (
                <div className="flex justify-end">
                        <span className="mt-1 w-fit flex items-center gap-1 flex-shrink-0 px-1.5 py-0.5 border border-orange-300 bg-orange-50 rounded-full whitespace-no-wrap">
                            <span className="w-1.5 h-1.5 bg-orange-400 rounded-full flex-shrink-0"/>
                            <span className="font-medium text-2xs text-orange-500 leading-tight">
                                {t('temporarily inactive')}
                            </span>
                        </span>
                </div>
            )}
        </div>
    )
}

export const renderTeacherTableRow = ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        active,
        user, fullname, gender,
        date_of_birth,
        contact_phone, contact_email,
        teacher_idcode,
        occupation, fields, degrees,
    } = item ?? {}

    const inactive = item?.active === 0
    const initials = getInitials(fullname)
    const color = getGroupColor(fullname)
    const isUserLinked = !!user?.id
    const birthYear = date_of_birth ? formatDate(date_of_birth, 'YYYY') : null

    return (
        <tr key={index} className="border-t border-color-50 background hover:background-50 transition-colors">
            <td className="px-3 py-2.5">
                <div className={classNames("flex items-center gap-2.5 min-w-0", inactive && "opacity-40")}>
                    {getAvatar(item) || user?.avatar ? (
                        <Avatar
                            size={36}
                            className="flex-shrink-0 flex flex-center background-200"
                            src={getAvatar(item) || user?.avatar}
                            icon={<FaUserTie size={16} className="text-color-500"/>}
                        />
                    ) : (
                        <div
                            style={{width: 36, height: 36, backgroundColor: color, flexShrink: 0}}
                            className="rounded-full flex flex-center">
                            <span className="text-white font-bold text-xs leading-none">{initials}</span>
                        </div>
                    )}
                    <div className="flex flex-col flex-1 min-w-0">
                        {renderTeacherHeader({item, t, onView: () => handleAction(TeacherActionTypes.TEACHER_READ, item)})}
                        {/* Giới tính + ngày sinh gộp vào cột Giảng viên để nhận dạng nhanh */}
                        {(gender === 1 || gender === 2 || date_of_birth) && (
                            <div className="mt-0.5 flex items-center gap-1.5 flex-wrap text-2xs text-color-300">
                                {renderGenderBadge(gender, t)}
                                {date_of_birth && (
                                    <span className="whitespace-no-wrap">{formatDate(date_of_birth, 'DD/MM/YYYY')}</span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {inactive && (
                    <div className="flex justify-end">
                        <span className="mt-1 w-fit flex items-center gap-1 flex-shrink-0 px-1.5 py-0.5 border border-orange-300 bg-orange-50 rounded-full whitespace-no-wrap">
                            <span className="w-1.5 h-1.5 bg-orange-400 rounded-full flex-shrink-0"/>
                            <span className="font-medium text-2xs text-orange-500 leading-tight">
                                {t('temporarily inactive')}
                            </span>
                        </span>
                    </div>
                )}
            </td>
            <td className={classNames("px-3 py-2.5", inactive && "opacity-40")}>
                {teacher_idcode && (
                    <span
                        onClick={() => { copyToClipboard(teacher_idcode); message.info(t('copied')) }}
                        className="font-mono text-xs text-blue-500 hover:text-blue-700 cursor-pointer flex items-center gap-1 whitespace-no-wrap">
                        #{teacher_idcode}
                        <IoCopyOutline size={9}/>
                    </span>
                )}
            </td>
            {/* TÀI KHOẢN USER - chỉ hiện @username, không cần chữ "Có User" */}
            <td className={classNames("px-3 py-2.5", inactive && "opacity-40")}>
                {isUserLinked && user?.username ? (
                    <span className="px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-600 font-mono text-2xs font-semibold flex items-center gap-1 w-fit whitespace-no-wrap">
                        @{user.username}
                    </span>
                ) : (
                    <span className="text-xs text-color-400 italic">{t('not update')}</span>
                )}
            </td>
            <td className={classNames("px-3 py-2.5", inactive && "opacity-40")}>
                <div className="flex gap-1 min-w-0">
                    {occupation && <span className="px-0.5 text-xs text-color-200 truncate"><GoDotFill size={8}/> {occupation}</span>}
                    {degrees && <span className="px-0.5 text-xs text-color-200 truncate"><GoDotFill size={8}/> {degrees}</span>}
                    {fields && <span className="px-0.5 text-xs text-color-200 truncate"><GoDotFill size={8}/> {fields}</span>}
                </div>
            </td>
            <td className={classNames("px-3 py-2.5", inactive && "opacity-40")}>
                <div className="flex flex-col gap-0.5 text-xs text-color-300">
                    <span className="flex items-center gap-1 whitespace-no-wrap">
                        <HiPhone size={10} className="flex-shrink-0"/>
                        {contact_phone || <span className="italic">{t('not update')}</span>}
                    </span>
                    <span className="flex items-center gap-1 truncate max-w-40">
                        <MdOutlineEmail size={10} className="flex-shrink-0"/>
                        {contact_email || <span className="italic">{t('not update')}</span>}
                    </span>
                </div>
            </td>
            <td className="px-3 py-2.5">
                <div className="flex items-center justify-end gap-2">
                    <button
                        type="button"
                        onClick={() => handleAction(TeacherActionTypes.TEACHER_READ, item)}
                        style={{width: 28, height: 28}}
                        className="flex flex-center rounded-full border border-color-200 hover:border-primary hover:background-100 text-color-400 hover:text-primary">
                        <BsEyeFill size={13}/>
                    </button>
                    {renderContextMenu(item)}

                </div>
            </td>
        </tr>
    )
}
